
import Vue from 'vue';
import IdentityVerification from '@/plugins/identityVerification';

export default Vue.extend({
  name: 'IdAlerts',
  data: () => ({
  }),
  props: {
    alerts: {
        required: true,
        type: Object || null,
    },
  },
  methods: {
  },
});
